import { render } from "./DbLookupForm.vue?vue&type=template&id=5f85c796&ts=true"
import script from "./DbLookupForm.vue?vue&type=script&lang=ts"
export * from "./DbLookupForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__